<template>
  <section v-if="name === 'navigation'" class="section">
    <div class="section-header with-border">
      设置
    </div>
    <div class="section-body">
      <el-form label-width="100px">
        <el-form-item label="组件间距">
          <el-switch
            v-model="base.padded"
            active-color="#27cc6a"
            inactive-color="#efefef">
          </el-switch>
        </el-form-item>
        <!-- <el-form-item label="类型">
          <template v-for="(item, index) in checkItem">
            <input type="checkbox" v-model="item.state" @click="CheckItem(index)"/>{{ item.name }}
          </template>
        </el-form-item> -->
        <el-form-item label="导航项">
          <!-- <draggable v-model="data" :options="dragIssuesOptions" @start="onStart" @end="onEnd"> -->
          <div class="setting-item" v-for="(item, index) in data" :key="index">
            <div class="setting-remove" @click="removeItem(index)"><i class="iconfont icon-trash-alt"></i></div>
            <img v-if="item.imgUrl" :src="wximageurl + item.imgUrl" class="banner-uploader square" @click="handleImgChange(index)"/>
            <div class="banner-uploader square" v-else @click="handleImgChange(index)">
              <div class="content-center">
                <i class="iconfont icon-camera"></i><br>
                上传图片
              </div>
            </div>
            <div class="uploader-setting">
              <el-input placeholder="导航名称" v-model="item.content"></el-input>
              <div class="goods-select" @click="handleGoodsChange(index)">
                <div class="link-content" v-if="item.id">
                  <template v-if="item.linkPage === 'goods'">商品：</template>
                  <template v-if="item.linkPage === 'category'">分类：</template>
                  <template v-if="item.linkPage === 'article'">文章：</template>
                  <template v-if="item.linkPage === 'planting'">软文：</template>
                  <template v-if="item.linkPage === 'link'">页面：</template>
                  <template v-if="item.linkPage === 'marketing'">营销：</template>
                  <template v-if="item.linkPage === 'custom_link'">自定义链接：</template>
                  <template v-if="item.linkPage === 'store_list'">店铺类型：</template>
                  {{item.title}}
                </div>
                <div v-else class="content-center"><i class="iconfont icon-link" @click="handleGoodsChange(index)"></i>设置路径</div>
              </div>
            </div>
          </div>
          <div class="frm-tips">只能上传jpg/png文件，且不超过2M （建议尺寸：375px * 200px）</div>
          <el-button :disabled="data.length >= 20" type="default" class="iconfont icon-plus-circle banner-button-uploader" @click="addItem"> 添加项目</el-button>
          <!-- </draggable> -->
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    components : {
      draggable,
    },
    props: {
      res: {
        type: Object,
        default: {}
      }
    },
    watch: {
      res: {
        deep: true,
        handler (value) {
          if (value) {
            this.setData(value)
            var checkArr = this.checkItem;
            if(this.base != undefined){
              if (this.base.type) {
                var typeArr = this.base.type;
                // console.log(11,typeArr)
                for (var i = 0; i < checkArr.length; i++) {
                  for (var j = 0; j < typeArr.length; j++) {
                    if (typeArr[j] == checkArr[i]['name']) {
                        checkArr[i]['state'] = true;
                        break;
                    }
                    else{
                        checkArr[i]['state'] = false;
                    }
                  }
                }
              }else{
                for (var i = 0; i < checkArr.length; i++) {
                  checkArr[i]['state'] = true;
                }
                this.operateCheck();
              }
              this.checkItem = checkArr;
            }
          }
        }
      }
    },
    data () {
      return {
        name: '',
        base: {},
        config: {},
        data: [],
        checkItem:[{
          name:'app',
          state:true
        },
        {
          name:'h5',
          state:true
        },
        {
          name:'wxapp',
          state:true
        }],
        dragIssuesOptions: {
          group: {
            name: 'easyview'
          },
          animation: 300,
          forceFallback: true,
          scroll: true,
          sort: true,
        },
      }
    },
    methods: {
      setData(val) {
        this.name = val.name
        this.base = val.base
        this.config = val.config
        this.data = val.data
      },
      // 拖拽绑定事件
      onStart (evt) {
        // 记录拖拽前的数据
        // this.saveInit = JSON.stringify(this.data[evt.oldIndex])
        console.log(this.data)
      },
      onEnd (evt) {
        // 将拖拽前的数据插入到拖拽后的位置
        // this.data.splice(evt.oldIndex, 0, JSON.parse(this.saveInit))
        // 删除拖拽前的数据
        // this.data.splice(evt.oldIndex, 1)
        console.log(this.data)
        this.$emit('bindSort', this.data)
      },
      removeItem (index) {
        this.data.splice(index, 1)
      },
      addItem () {
        if (!this.data) {
          this.data = []
        }
        let item = {
          imgUrl: '',
          linkPage: '',
          content: '',
          id: ''
        }
        if(this.data.length > 20) {
          this.$message({
            message: '轮播图最多添加20个图片',
            type: 'error',
            duration: 5 * 1000
          })
        } else {
          this.data.push(item)
        }
      },
      handleImgChange (index) {
        this.$emit('bindImgs', index)
      },
      handleGoodsChange (index) {
	      this.$emit('bindLinks', index)
      },
      cbClick(index){
        console.log('复选框',index)
      },
      CheckItem:function(index){
        this.checkItem[index]['state'] = !this.checkItem[index]['state'];
        this.operateCheck();
      },
      operateCheck(){
        const  type_arr = [];
        this.checkItem.forEach((item,key) => {
          if (item['state']) type_arr.push(item['name']);
        });
        console.log('click',this.checkItem);
        this.$emit('bindType', type_arr);
      }
    },
    mounted() {
      this.setData(this.res)
    }
  }
</script>

<style scoped lang="scss">
  input[type="checkbox"]{ -webkit-appearance: none;width:20px;height:20px; border-radius: 50%; display: inline-block;text-align: center;vertical-align: middle; line-height: 18px;position: relative;margin-right: 10px;}
  input[type="checkbox"]::before{content: "";position: absolute;border-radius: 50%;top: 0;left: 0;background: #fff;width: 100%;height: 100%;border: 1px solid #d9d9d9}
  input[type="checkbox"]:checked::before{content: "\2713";border-radius: 50%; background-color: rgb(108,184,89);position: absolute;top: 0;left: 0;width:100%;border: 1px solid  rgb(108,184,89);color: white;font-size: 20px;font-weight: bold;}
</style>



// WEBPACK FOOTER //
// navigation.vue?437fbbb7